import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="participant"
export default class extends Controller {
  static targets = ["container", "template", "participant"]

  connect() {
    this.index = this.participantTargets.length + 1
  }

  add(event) {
    event.preventDefault()
    const content = this.templateTarget.innerHTML.replace(/{id}/g, `${this.index++}`)
    this.containerTarget.insertAdjacentHTML("beforeend", content)
  }

  remove(event) {
    event.preventDefault()
    const participantEl = event.target.closest("[data-participant-target='participant']")
    if (participantEl) {
      participantEl.remove()
    }
  }
}
